// src/components/SaaS/UserComments.js
import React, { useState, useEffect } from 'react';
import { fetchUserComments, addUserComment } from '../../services/api'; // Use user-specific APIs

const UserComments = ({ postSlug, isAuthenticated, token }) => {
    const [comments, setComments] = useState([]);
    const [commentContent, setCommentContent] = useState('');

    useEffect(() => {
        const getComments = async () => {
            try {
                const commentsData = await fetchUserComments(postSlug);
                const sortedComments = commentsData.sort(
                    (a, b) => new Date(b.created_on) - new Date(a.created_on)
                );
                setComments(sortedComments);
            } catch (error) {
                console.error('Failed to fetch user comments:', error);
            }
        };
        getComments();
    }, [postSlug]);

    const handleCommentSubmit = async (e) => {
        e.preventDefault();
        if (!commentContent.trim()) return;

        try {
            const commentData = { content: commentContent };
            const newComment = await addUserComment(postSlug, commentData, token);
            setComments([newComment, ...comments]);
            setCommentContent('');
        } catch (error) {
            console.error('Failed to add comment:', error);
        }
    };

    return (
        <div>
            <h3 className='mb-3'>Drop your two cents</h3>

            {!isAuthenticated ? (
                <div className="alert alert-info" role="alert">
                    Please <a href="/login" className="alert-link">sign in</a> or <a href="/register" className="alert-link">sign up</a> to leave a comment.
                </div>
            ) : (
                <form onSubmit={handleCommentSubmit}>
                    <div className="mb-3">
                        <textarea
                            className="form-control"
                            rows="3"
                            value={commentContent}
                            onChange={(e) => setCommentContent(e.target.value)}
                            placeholder="Add a comment"
                        />
                    </div>
                    <button type="submit" className="btn btn-dark mb-5 fw-bold">Submit Comment</button>
                </form>
            )}

            <div>
                {comments.length === 0 ? (
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="d-flex flex-column text-start me-4">
                            <h4 className='fw-bold'>Got something clever to say?</h4>
                            <p>Be the first to drop a comment. 😎</p>
                        </div>
                        <div>
                            <img
                                src="https://res.cloudinary.com/dnbbm9vzi/image/upload/v1726666674/20_hggzzz.png"
                                alt="No comments yet"
                                style={{ width: '250px', height: 'auto' }}
                            />
                        </div>
                    </div>
                ) : (
                    comments.map((comment) => (
                        <div key={comment.id} className="mb-4 d-flex align-items-start">
                            <img
                                src={comment.profile_image || 'https://res.cloudinary.com/dnbbm9vzi/image/upload/v1736169445/cartoonish_animated_black_and_white_profile_image_of_a_jester_facing_forward_ixolqj.jpg'}
                                alt={`${comment.username || 'User'}'s profile`}
                                className="rounded-circle me-3"
                                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                            />
                            <div>
                                <p>
                                    <strong>{comment.username || 'Anonymous'}:</strong> {comment.content}
                                </p>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default UserComments;
